export default __webpack_public_path__ + "static/media/lin.e286a923.svg";